import React, { useState } from "react";
import PagesNav from "./PagesNav";
import Header from "./Header";
import { Modal, Button } from "react-bootstrap";
const Herosection = () => {
  const [openchatbot, setOpenChatbot] = useState(false);

  return (
    <div
      className="relative z-0 overflow-hidden h-[75vh] md:min-h-[650px] rounded-xl m-2"
      style={{
        backgroundImage: 'url("/assets/images/hero-bgcopy.webp")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* {openchatbot && (
        <Modal
          show={openchatbot}
          onHide={setOpenChatbot}
          dialogClassName="min-w-[95vw] xl:min-w-[70vw]"
        >
          <Modal.Header
            // closeButton
            className="custom-modal-header btn-close-black"
            style={{
              borderBottomColor: "black",
            }}
          >
            <Modal.Title>Ask Your Question</Modal.Title>
            <button
              type="button"
              class="btn "
              data-bs-dismiss="modal"
              style={{ color: "black" }}
              onClick={() => setOpenChatbot(false)}
            >
              <i class="fas fa-close"></i>
            </button>
          </Modal.Header>
          <Modal.Body className="w-full"></Modal.Body>
        </Modal>
      )} */}
      <div className="z-20 w-full flex flex-col justify-center items-center py-32">
        <div className="max-w-[1480px] w-full h-full flex flex-col justify-center items-center mx-auto z-10 py-auto">
          <PagesNav openchatbot={openchatbot} setOpenChatbot={setOpenChatbot} />
        </div>
      </div>
    </div>
  );
};

export default Herosection;
